import { createContext, useContext } from "react";
export const EditorActionsContext = createContext(null);
const EMPTY_SELECTION = new Set();
/**
 * The editor's own multi-selection — the authoritative model, which
 * deliberately diverges from xyflow's `node.selected` (controlled selection,
 * note link mode). Provided around the context-menu tree; empty for consumers
 * rendered outside an editor.
 */ export const EditorSelectionContext = createContext(EMPTY_SELECTION);
export function useEditorSelectedNodeIds() {
    return useContext(EditorSelectionContext);
}
export function useEditorActions() {
    const ctx = useContext(EditorActionsContext);
    if (!ctx) throw new Error("useEditorActions must be used within EditorActionsContext");
    return ctx;
}
export { EdgeCallbacksContext, EdgeWaypointActionsContext, useEdgeCallbacksRef, useEdgeWaypointActions } from "../core/contexts/edgeCallbacks";

//# sourceMappingURL=editorContexts.js.map